// SPDX-FileCopyrightText: 2026 Ebiose AI
// SPDX-License-Identifier: LicenseRef-Ebiose-Proprietary
// All rights reserved. Confidential — unauthorized distribution prohibited.

import { Link } from "react-router-dom"

export function NotFoundView() {
  return (
    <div className="flex flex-col items-center justify-center p-8 h-full gap-4">
      <div className="text-2xl font-bold">404</div>
      <div>This page does not exist.</div>
      <div>
        <Link to="/" className="text-blue-500 underline">
          Go back home
        </Link>
      </div>
    </div>
  )
}
